module.exports = __webpack_public_path__ + "static/media/A1.187690ce.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/A1.png
// module id = 865
// module chunks = 0